import React,{ Component, Fragment } from "react";
import InputText from "../common/Form";

import Button from '@mui/material/Button';
import DialogBox from "../../container/MUI/DialogBox";

import TextField from '@mui/material/TextField';
import { Box, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

class Login extends Component{
    state = {
        open: false,
        showPassword: false
    }
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render(){
        console.log('[INFO], Login, State,',this.state);
        console.log(this.props);
        const { showPassword } = this.state;
        return(
            <Box>
                {/* <DialogBox                     
                    open={this.props.openPassword} 
                    close={this.props.closeForgetPassword} 
                    title="Réinitialiser le Mot de Passe" 
                    disableBackdropClick >
                        <InputText 
                        onChange={this.props.handleChange} 
                        name="resetEmail" 
                        value={this.props.resetEmail} 
                        placeholder="Email ici" 
                        title="Email" 
                        error={this.props.errors.resetEmail} 
                        classes="form-control-lg" />

                        <div>
                            <Button color="primary" variant="contained" onClick={this.props.handleReset} >Envoyer</Button>
                            <Button color="default" onClick={this.props.closeForgetPassword} >Annuler</Button>
                        </div>
                </DialogBox> */}
                <Box> 
                    {/* <InputText 
                    onChange={this.props.handleChange} 
                    name="email" 
                    value={this.props.email} 
                    placeholder="Email ici" 
                    title="Email" 
                    error={this.props.errors.email} 
                    classes="form-control-lg" /> */}
                     {/* <InputText 
                    onChange={this.props.handleChange} 
                    name="password" 
                    value={this.props.password} 
                    placeholder="Mot de passe ici" 
                    title="Mot de Passe" 
                    classes="form-control-lg" 
                    type="password" /> */}
               
                    <InputText
                        required
                        name="email" 
                        id="email" 
                        value={this.props.email} 
                        label="Email" 
                        placeholder="Email ici" 
                        error={this.props.errors.email} 
                        onChange={this.props.handleChange} 
                    />
                    <InputText
                        required
                        type="password"
                        name="password" 
                        id="password" 
                        value={this.props.password} 
                        label="Mot de Passe" 
                        placeholder="Mot de Passe ici" 
                        error={this.props.errors.password} 
                        onChange={this.props.handleChange} 
                        type={showPassword ? 'text' : 'password'}
                        endAction={
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => this.setState({showPassword: !showPassword})}
                                // onMouseDown={handleMouseDownPassword}
                                edge="end"
                            >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                            
                        }
                    />
                </Box>
                
                <Box p={2} style={{textAlign: "center"}} >
                    <Button color="secondary" variant="contained" size="large" onClick={()=>this.props.handleSubmit("login")} >
                    Se Connecter
                    </Button>
                </Box>
                {/* <hr/> */}
                {/* <p className="a-like" onClick={this.props.openForgetPassword}>Mot de Passe oublié ?</p> */}
            </Box>
        )
    }
}

export default Login;